(function () {
    'use strict';
    // DO NOT EDIT THIS FILE, EDIT THE GULP TASK NGCONSTANT SETTINGS INSTEAD WHICH GENERATES THIS FILE
    angular
        .module('prelimApp')
        .constant('CONST_PRELIM', {
        	'REWARD_LETTER':'Danh sách Quà tặng/ Thư KSK',
        	'OFFICE_CODE':'Mã văn phòng',
        	'CLIENT_CODE':'Mã số khách hàng',
        	'CLIENT_NAME':'Họ tên khách hàng',
        	'GOODWILL_TYPE':'Loại ưu đãi',
        	'GOODWILL_NAME':'Tên ưu đãi',
        	'GOODWILL_CODE':'Mã đợt gửi ưu đãi của P.CSKH',
        	'SENT_DATE':'Ngày P.CSKH gửi quà/thư',
        	'AGENT_CODE':'Mã số tư vấn viên',
        	'AGENT_NAME':'Họ tên tư vấn viên',
        	'REQUEST_DATE':'Ngày yêu cầu ưu đãi',
        	'AGENT_ACCEPTED_DATE':'Ngày tư vấn viên nhận',
        	'RECEIVER_INSTEAD_CODE':'Mã số người nhận/Người nhận thay',
        	'RECEIVER_INSTEAD_NAME':'Người nhận/Người nhận thay',
        	'RETURN_LETTER_DATE':'Ngày trả quà/thư về Care',
        	'NOTE':'Ghi chú',
			'STATUS':'Tình trạng giao nhận',
			'SUCCESS':'Thành công',
			'FAIL':'Không thành công',
			'NONE':'Chưa cập nhật',
			'SEARCH':'Tìm kiếm',
			'FROM_DATE':'Từ ngày',
			'TO_DATE':'Đến ngày',
			'UPDATE_INFO_PRELIM_PRU_REWARD':'Cập nhật thông tin giao nhận',
			'REPORT_PRELIM_PRU_REWARD':'Báo cáo Quà tặng/Thư khám sức khỏe',
			'REPORT_GENERAL_PRELIM_PRU_REWARD':'Báo cáo tổng hợp Quà tặng/ Thư của tất cả GA',
			'REPORT_DETAIL_PRELIM_PRU_REWARD':'Báo cáo chi tiết Quà tặng/ Thư của tất cả GA',
			'REPORT_REMAINING_PRELIM_PRU_REWARD':'Báo cáo xử lý tồn Quà tặng/ Thư của tất cả GA'
        });
})();
